import axios from "axios";
import {
  SMVM_GET_ASPECT_GUIDE_FAIL,
  SMVM_GET_ASPECT_GUIDE_REQUEST,
  SMVM_GET_ASPECT_GUIDE_RESET,
  SMVM_GET_ASPECT_GUIDE_SUCCESS,
  SMVM_GET_ASSESSEE_GUIDE_FAIL,
  SMVM_GET_ASSESSEE_GUIDE_REQUEST,
  SMVM_GET_ASSESSEE_GUIDE_RESET,
  SMVM_GET_ASSESSEE_GUIDE_SUCCESS,
  SMVM_GET_ASSESSOR_GUIDE_FAIL,
  SMVM_GET_ASSESSOR_GUIDE_REQUEST,
  SMVM_GET_ASSESSOR_GUIDE_RESET,
  SMVM_GET_ASSESSOR_GUIDE_SUCCESS,
} from "../constants/GuideConstants";
import {
  API_GET_ASPECT_GUIDE,
  API_GET_ASSESSEE_GUIDE,
  API_GET_ASSESSOR_GUIDE,
} from "../init/api_url";
import { userDataLocalStorage } from "../../../general/functions/base64Function";

export const RGetAssessorGuide = () => async (dispatch) => {
  dispatch({
    type: SMVM_GET_ASSESSOR_GUIDE_RESET,
  });
};

export const GetAssessorGuide = (methodId) => async (dispatch) => {
  const { token, session } = userDataLocalStorage();
  let d = session.split("-");
  let sessionId = d[2];
  let projectCode = [d[0], d[1]].join("-");
  try {
    dispatch({
      type: SMVM_GET_ASSESSOR_GUIDE_REQUEST,
    });

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        projectCode: projectCode,
        methodId: methodId,
      },
    };
    const { data: data } = await axios.get(API_GET_ASSESSOR_GUIDE(), config);

    dispatch({
      type: SMVM_GET_ASSESSOR_GUIDE_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    dispatch({
      type: SMVM_GET_ASSESSOR_GUIDE_FAIL,
      payload: message,
    });
  }
};

export const RGetAssesseeGuide = () => async (dispatch) => {
  dispatch({
    type: SMVM_GET_ASSESSEE_GUIDE_RESET,
  });
};

export const GetAssesseeGuide = (methodId) => async (dispatch) => {
  const { token, session } = userDataLocalStorage();
  let d = session.split("-");
  let sessionId = d[2];
  let projectCode = [d[0], d[1]].join("-");

  try {
    dispatch({
      type: SMVM_GET_ASSESSEE_GUIDE_REQUEST,
    });

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        projectCode: projectCode,
        methodId: methodId,
      },
    };
    const { data: data } = await axios.get(API_GET_ASSESSEE_GUIDE(), config);

    dispatch({
      type: SMVM_GET_ASSESSEE_GUIDE_SUCCESS,
      payload: data?.data?.guidelineAssessee,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    dispatch({
      type: SMVM_GET_ASSESSEE_GUIDE_FAIL,
      payload: message,
    });
  }
};

export const RGetAspectGuide = () => async (dispatch) => {
  dispatch({
    type: SMVM_GET_ASPECT_GUIDE_RESET,
  });
};

export const GetAspectGuide = (methodId) => async (dispatch) => {
  const { token, session } = userDataLocalStorage();
  let d = session.split("-");
  let sessionId = d[2];
  let projectCode = [d[0], d[1]].join("-");
  try {
    dispatch({
      type: SMVM_GET_ASPECT_GUIDE_REQUEST,
    });

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        projectCode: projectCode,
        methodId: methodId,
      },
    };
    const { data: data } = await axios.get(API_GET_ASPECT_GUIDE(), config);

    dispatch({
      type: SMVM_GET_ASPECT_GUIDE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    dispatch({
      type: SMVM_GET_ASPECT_GUIDE_FAIL,
      payload: message,
    });
  }
};
